export class ProgramIdentifiersApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getProgramIdentifiers(params) {
    return this.#http.get('/program-identifiers', { params });
  }

  async createProgramIdentifiers(body) {
    return this.#http.post('/program-identifiers', body);
  }

  async getProgramIdentifiersById({ id, ...body }) {
    return this.#http.get(`/program-identifiers/${id}`, body);
  }

  async editProgramIdentifiers({ id, ...body }) {
    return this.#http.put(`/program-identifiers/${id}`, body);
  }

  async deletegetProgramIdentifiers({ id }) {
    return this.#http.delete(`/program-identifiers/${id}`);
  }
}
